/* 全局变量 */
const config = {
    dictionaryPre: 'zx_auth_dictionary_',
    userConfigName: 'userInfo',
    systemSize: 'mini',
    orgTreeName: 'orgTree',
    dictionary: {
        dictionaryType: 'dictionaryType',
        sex: 'sex',
        userStatus: 'userStatus',
        accountStatus: 'accountStatus',
        orgList: 'orgList'
    },
    resultCode: {
        success: '0',
        fail: '1',
        noAuth: '2',
        operateRepeat: '3',
        notLogin: '4'
    },
    dataType: {
        string: 'string',
        number: 'number',
        boolean: 'boolean',
        null: 'null',
        undefined: 'undefined',
        array: 'array',
        object: 'object',
        function: 'function'
    },
    businessFlag: {
        system: 'system',
        zxUser: 'zxUser',
        rtUser: 'rtUser'
    },
    handleType: {
        // 系统默认
        add: 'add',
        addBatch: 'addBatch',
        updateAll: 'updateAll',
        updateSelect: 'updateSelect',
        updateAllBatch: 'updateAllBatch',
        updateSelectBatch: 'updateSelectBatch',
        deletePhysical: 'deletePhysical',
        deleteLogical: 'deleteLogical',
        deletePhysicalBatch: 'deletePhysicalBatch',
        deleteLogicalBatch: 'deleteLogicalBatch',
        getInfoById: 'getInfoById',
        getListByCondition: 'getListByCondition',
        getAll: 'getAll',
        getPage: 'getPage',
        // 新增操作
        deleteAndAdd: 'deleteAndAdd',
        updateSelfInfo: 'updateSelfInfo',
        getTree: 'getTree',
        getPageNew: 'getPageNew',
        CoolScreen: 'CoolScreen',
        getBcpage: 'getBcpage',
        getBxpage: 'getBxpage',
        getAllBcpage: 'getAllBcPage',
        getAllBxpage: 'getAllBxPage',
        getVillages: 'getVillages',
        getVillagesGather: 'getVillagesGather',
        getVillagesCommittee: 'getVillagesCommittee',
        getTreeTwo: 'getTreeTwo',
        clTool: 'CLTool', // 作业量分析
        getTreeXz: 'getTreeXz', // 区域树
        TempServiceImpl: 'TempServiceImpl', // 分页
        kgpzInfo: 'kgpzInfo',
        getFei: 'getFei',
        getServeRanking: 'getServeRanking',
        getAllMyd: 'getAllMyd',
        Bxtool: 'Bxtool',
        Bctool: 'Bctool',
        Workbench: 'getBcListpage',
        getInform: 'getInform',
        jobInfo: 'jobInfo',
        gzphInfo: 'gzphInfo',
        zjList: 'zjList',
        addTwo: 'addTwo',
        gkBcSummary: 'gkBcSummary',
        gkBxSummary: 'gkBxSummary',
        bsXzMyd: 'bsXzMyd',
        totalbcbxNum: 'totalbcbxNum',
        getBsxzBxSummary: 'getBsxzBxSummary',
        getBsxzmyd: 'getBsxzmyd',
        getBsbcPage: 'getBsbcPage',
        getBsbxPage: 'getBsbxPage',
        getclInfo: 'getclInfo',
        getGcInfoTotal: 'getGcInfoTotal',
        totalNumberExport:'totalNumberExport',
        totalNumberExportJd:'totalNumberExportJd',
        getXcById: 'getXcById'


    },
    baseServiceType: {
        TGcBcxxServiceImpl: 'TGcBcxxServiceImpl',
        TGcGcdaServiceImpl: 'TGcGcdaServiceImpl',
        TGcBxxxServiceImpl: 'TGcBxxxServiceImpl',
        TGcOrganizationServiceImpl: 'TGcOrganizationServiceImpl',
        TGcClServiceImpl: 'TGcClServiceImpl',
        TGcTztgServiceImpl: 'TGcTztgServiceImpl',
        TGcRoleServiceImpl: 'TGcRoleServiceImpl',
        TGcZjjlServiceImpl: 'TGcZjjlServiceImpl',
        TSysLogServiceImpl: 'TSysLogServiceImpl',
        TGcFjServiceImpl: 'TGcFjServiceImpl'
    },
    dateFormat: {
        YMD: 'YYYY-MM-DD',
        yMd: 'yyyy-MM-dd',
        yMDHm: 'yyyy-MM-DD HH:mm',
        ymdhm: 'YYYY-MM-DD HH:mm',
        ymdhms: 'YYYY-MM-DD HH:mm:ss'
    },
    // 最多条数限制
    limitNum: {
        remind: 5,
        process: 10,
        hear: 5
    }
}
const message = {
    登陆成功: ''
}
const columns = {}
const mapData = {
  xzGps: [
    {
      name: '梁园镇',
      bcNumber: 60,
      bxNumber: 87,
      latitude: 31.996384,
      longitude: 117.555565
    },
    {
      name: '八斗镇',
      bcNumber: 60,
      bxNumber: 87,
      latitude: 32.158005,
      longitude: 117.610054
    },
    {
      name: '店埠镇',
      bcNumber: 60,
      bxNumber: 87,
      latitude: 31.909038834436906,
      longitude: 117.51251220703124
    },
    {
      name: '撮镇镇',
      bcNumber: 60,
      bxNumber: 87,
      latitude: 31.85189834587929,
      longitude: 117.43286132812499
    },
    {
      name: '桥头集镇',
      bcNumber: 60,
      bxNumber: 87,
      latitude: 31.759588,
      longitude: 117.55674
    },
    {
      name: '长临河镇',
      bcNumber: 60,
      bxNumber: 87,
      latitude: 31.690369,
      longitude: 117.461693
    },
    {
      name: '石塘镇',
      bcNumber: 60,
      bxNumber: 87,
      latitude: 31.932135,
      longitude: 117.633301
    },
    {
      name: '古城镇',
      bcNumber: 60,
      bxNumber: 87,
      latitude: 32.146362,
      longitude: 117.821518
    },
    {
      name: '元疃镇',
      bcNumber: 60,
      bxNumber: 87,
      latitude: 32.07962,
      longitude: 117.389503
    },
    {
      name: '白龙镇',
      bcNumber: 60,
      bxNumber: 87,
      latitude: 32.144249,
      longitude: 117.425285
    },
    {
      name: '包公镇',
      bcNumber: 60,
      bxNumber: 87,
      latitude: 31.941574,
      longitude: 117.675613
    },
    {
      name: '陈集镇',
      bcNumber: 60,
      bxNumber: 87,
      latitude: 32.201283,
      longitude: 117.762993
    },
    {
      name: '众兴乡',
      bcNumber: 60,
      bxNumber: 87,
      latitude: 32.002041,
      longitude: 117.418556
    },
    {
      name: '张集乡',
      bcNumber: 60,
      bxNumber: 87,
      latitude: 32.041679,
      longitude: 117.674416
    },
    {
      name: '马湖乡',
      bcNumber: 60,
      bxNumber: 87,
      latitude: 32.055836,
      longitude: 117.816254
    },
    {
      name: '响导乡',
      bcNumber: 60,
      bxNumber: 87,
      latitude: 32.209797,
      longitude: 117.617661
    },
    {
      name: '杨店乡',
      bcNumber: 60,
      bxNumber: 87,
      latitude: 32.12529,
      longitude: 117.532196
    },
    {
      name: '牌坊回族满族乡',
      bcNumber: 60,
      bxNumber: 87,
      latitude: 31.956078,
      longitude: 117.480881
    }
  ]
}
export default {
    config,
    message,
    columns,
    mapData
}



// WEBPACK FOOTER //
// ./src/assets/js/global.js